import { LOCAL_STORAGE_AUTH_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN } from '../constants/localStorage';

export class LocalStorageService {
  private static isBrowser() {
    return typeof window !== 'undefined';
  }

  private static getSessionStorage(): Storage | null {
    if (!LocalStorageService.isBrowser() || !('sessionStorage' in globalThis)) return null;
    return sessionStorage;
  }

  private static getLocalStorage(): Storage | null {
    if (!LocalStorageService.isBrowser() || !('localStorage' in globalThis)) return null;
    return localStorage;
  }

  private static getItem(key: string): string | null {
    const session = LocalStorageService.getSessionStorage();
    const local = LocalStorageService.getLocalStorage();

    const fromSession = session?.getItem(key) ?? null;
    const fromLocal = local?.getItem(key) ?? null;

    if (fromSession && !fromLocal) {
      local?.setItem(key, fromSession);
    } else if (fromLocal && !fromSession) {
      session?.setItem(key, fromLocal);
    }

    return fromSession ?? fromLocal;
  }

  private static setItem(key: string, value: string): void {
    LocalStorageService.getSessionStorage()?.setItem(key, value);
    LocalStorageService.getLocalStorage()?.setItem(key, value);
  }

  private static removeItem(key: string): void {
    LocalStorageService.getSessionStorage()?.removeItem(key);
    LocalStorageService.getLocalStorage()?.removeItem(key);
  }

  static getAccessToken(): string | null {
    return LocalStorageService.getItem(LOCAL_STORAGE_AUTH_TOKEN);
  }

  static setAccessToken(token: string): void {
    LocalStorageService.setItem(LOCAL_STORAGE_AUTH_TOKEN, token);
  }

  static clearAccessToken(): void {
    LocalStorageService.removeItem(LOCAL_STORAGE_AUTH_TOKEN);
  }

  static getRefreshToken(): string | null {
    return LocalStorageService.getItem(LOCAL_STORAGE_REFRESH_TOKEN);
  }

  static setRefreshToken(token: string): void {
    LocalStorageService.setItem(LOCAL_STORAGE_REFRESH_TOKEN, token);
  }

  static clearRefreshToken(): void {
    LocalStorageService.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  }

  static clearAllTokens(): void {
    LocalStorageService.clearAccessToken();
    LocalStorageService.clearRefreshToken();
  }
}
